import React, { Component } from 'react'
import { Link } from "react-router-dom";
import withRouter from "../withRouter.js";
import MasterService from './MasterService.js';
import { userid } from "../Common/Credentials.js";
import { spin } from '../Common/NewLoader'
import moment from 'moment';
import CustomToolbar from '../CommonComponents/CustomToolbar.js';
import MUIDataTable from 'mui-datatables';

import { toast } from "../NewUI/NewComponents/toastService";


import ViewIcon from "../images/Icons/preview.png"
import LockIcon from "../images/Icons/reset-password.webp"

import { ThemeProvider, Tooltip } from "@mui/material";
import { createTheme } from "@mui/material";
import Breadcrumb from '../NewUI/NewComponents/Breadcrumb.jsx';
import UserService from '../users/UserService.js';


const theme = createTheme({
  overrides: {
    MuiTableCell: {
      head: {
        backgroundColor: "#e9ecef !important",
        border: [[1, 'solid', '#ece6e6']],
      },
      body:
      {
        border: [[1, 'solid', '#ece6e6']],
      },
    },
  },
});
class MasterDataTable extends Component {


  constructor(props) {
    super(props)

    this.state = {
      tenants: [],
      loading: false

    }
    this.refreshTenants = this.refreshTenants.bind(this)
    this.deleteTenant = this.deleteTenant.bind(this)
  }



  deleteTenant(id) {
    MasterService.deleteTenant(id)
      .then(
        resposne => {
          this.setState({ message: `Delete of Todo ${id} Successfull` })
          this.refreshTenants()
        }
      ).catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      })


  }

  handleResetAdminPassword(id){
    UserService.resetAdminUserPassword(id).then((res)=>{
      toast(res?.data?.message,"success")
    }).catch(()=>{
      toast("Unable to reset password","error")
    })
  }


  refreshTenants() {

    if (userid === undefined) {
      window.confirm('Your Session is Lost: Please login Back to resume')
      this.props.navigate(`/`)
    }

    this.setState({ loading: true })
    MasterService.retriveAllTenants()
      .then(
        response => {
          this.setState({ tenants: response.data.sort((a, b) => (a.id < b.id ? -1 : 1)) })
          const script = document.createElement("script");
          script.src = '../js/content.js';
          script.async = true;
          document.body.appendChild(script);
          this.setState({ loading: false })
        }
      )
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      })
  }

  componentDidMount() {


    this.refreshTenants();

  }

  render() {

    const columns = [
      {
        name: "id",
        label: "Client Id",
        options: {
          filter: true,
          sort: true,
          // sortOrder: "asc",
          // display: false, viewColumns: false
        },
      },
      {
        name: "companyname",
        label: "Company",
        options: { filter: false, sort: true },
      },
      {
        name: "contactname",
        label: "Contact",
        options: { filter: false, sort: true },
      },
      {
        name: "contactnumber",
        label: "Number",
        options: {
          filter: false, sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>+{this.state.tenants.find((e) => e.id === tableMeta.rowData.find((e) => e)).phonecode} {value}</div>
            )
          },
        },
      },
      { name: "email", label: "Email", options: { filter: false, sort: true } },
      {
        name: "prefix",
        label: "Prefix",
        options: { filter: true, sort: true },
      },
      {
        name: "city",
        label: "City",
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>{this.state.tenants.find((e) => e.id === tableMeta.rowData.find((e) => e))?.city?.name}</div>
            )
          },
        },
      },
      {
        name: "createdAt", label: "Date", options: {
          filter: false, sort: false, sortOrder: 'asc', display: false, viewColumns: false,
          customBodyRender: (tableMeta) => {
            return (moment(tableMeta).format('DD-MM-YYYY'))
          }
        }
      },
      { name: "clientactive", label: "Status", options: { filter: false, sort: true } },
      {
        name: "Actions",
        options: {
          filter: false,
          sort: false,
          empty: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return tableMeta.rowData.find((e) => e) !== userid ? (
              <div className='tw-flex tw-gap-x-2'>
                <Tooltip title="View Details">
                  <Link
                    to={{ pathname: "/tenantdetails" }}
                    state={{
                      id: tableMeta.rowData.find((e) => e),
                      data: this.state.tenants.find(t => t.id === tableMeta.rowData.find((e) => e)),
                    }}
                  >
                    <img
                      src={ViewIcon}
                      alt="View"
                      style={{ width: "1.3rem", height: "1.3rem", cursor: "pointer" }}
                    />
                  </Link>
                </Tooltip>
                <Tooltip title="Reset Admin Password">
                  <button
                    onClick={()=>this.handleResetAdminPassword(tableMeta.rowData.find((e) => e))}
                  >
                    <img
                      src={LockIcon}
                      alt="View"
                      style={{ width: "1.3rem", height: "1.3rem", cursor: "pointer" }}
                    />
                  </button>
                </Tooltip>
              </div>
            ) : (
              "NA"
            );
          },
        },
      }

    ];

    const options = {
      // filterType: "checkbox",
      selectableRows: "none",
      customToolbar: () => {
        return (
          <>
            <Link
              as="button"
              className="float-right btn btn-sm m-0 p-0"
              to={{
                pathname: "/newtenant"
              }}
              state={{ id: -1, name: 'New Tenant' }}
            >
              <CustomToolbar />
            </Link>
          </>
        );
      },
    };


    return (
      <div className='UI-container'>
        <div className="UI-card">
        <div className={`UI-header`}>
          <Breadcrumb breadcrumbs={[{name:"Home",path:"/superadminmasters"},{name:"Tenants",path:null}]}/>
        </div>
                    <div className="UI-table-container ">
                        <div>{this.state.loading === true ? <div className="text-center">{spin}</div> :
                          <ThemeProvider theme={theme}>
                            <MUIDataTable
                              className="table-sm"
                              title={"Tenants"}
                              data={this.state.tenants}
                              columns={columns}
                              options={options}
                            />
                          </ThemeProvider>
                        }</div>

                    </div>
        </div>

      </div>


    )

  }

}
export default withRouter(MasterDataTable)